//#region IMPORT
import { Button, Dialog } from '../../../../Components/MUIs';
import { Box, Stack, Typography } from '@mui/material';
import DocumentViewer from '../../../../Components/Ui/DocumentViewer';
import { Group as GroupIcon } from '@mui/icons-material';
import Lottie from 'lottie-react';
import AiAnimation from '../../../../Assets/animations/Loading.json';
//#endregion

export default function M_TBM_CUSTOM_03(props) {
  const fileUrl = props.fullUrl;
  const ext = props.getExtensionFromUrl(fileUrl);

  const isImage = ['jpg', 'jpeg', 'png'].includes(ext);
  const isPdf = ext === 'pdf';

  const renderViewer = () => {
    if (!fileUrl) {
      return (
        <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
          교육 자료가 없습니다.
        </Typography>
      );
    }

    if (isImage) {
      return (
        <img
          src={fileUrl}
          alt="교육자료 이미지"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '70vh',
            objectFit: 'contain',
          }}
        />
      );
    }

    if (isPdf) {
      return (
        <DocumentViewer
          fileUrl={fileUrl}
          renderPreview={props.renderPreview}
          loading={props.loading}
          onDocumentLoadSuccess={props.onDocumentLoadSuccess}
          pageNumber={props.pageNumber}
          pageWidth={props.pageWidth}
          pageViewHeight={props.pageViewHeight}
          setPageViewHeight={props.setPageViewHeight}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      );
    }

    return (
      <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
        미리보기를 지원하지 않는 파일 형식입니다.
      </Typography>
    );
  };

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          교육 자료
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          PDF 자료를 통해 교육을 시작해주세요.
        </Typography>
      </Stack>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          overflow: 'hidden',
        }}
      >
        {renderViewer()}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ p: 2, width: '100%' }}
        >
          <Button
            sx={{ width: '100%', height: '36px', borderRadius: '18px' }}
            name="이전"
            onClick={props.goToPrevPage}
          />
          <Typography
            sx={{
              fontWeight: 'bold',
              mx: 6,
              whiteSpace: 'nowrap',
            }}
          >
            {fileUrl && props.numPages > 0
              ? `${props.pageNumber} / ${props.numPages}`
              : null}
          </Typography>
          <Button
            sx={{ width: '100%', height: '36px', borderRadius: '18px' }}
            name={
              props.pageNumber === props.numPages || !props.fullUrl
                ? '완료'
                : '다음'
            }
            onClick={() => {
              if (props.numPages > 0 && props.pageNumber < props.numPages) {
                props.goToNextPage();
                return;
              }

              props.setActiveStep(props.activeStep + 1);
            }}
          />
        </Stack>
      </Box>
      {props.modalToggle2 && (
        <Dialog
          open={props.modalToggle2}
          sx={{ height: '90vh' }}
          titleSx={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#D9D9D9',
            pt: 3,
            pb: 1.5,
          }}
          contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)',
              maxWidth: '100%',
            },
          }}
          fullWidth={true}
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => { }}
          maxWidth={false}
          content={
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Lottie
                animationData={AiAnimation}
                loop
                autoplay
                style={{
                  display: 'flex',
                  width: '50px',
                  height: '30px',
                  overflow: 'hidden',
                  transform: 'scale(4)',
                }}
              />
              <Box>
                <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                  교육이 종료되었습니다.
                </Typography>
                <Typography>TBM완료 후 AI콜을 진행해주세요.</Typography>
              </Box>
              <Box
                sx={{
                  pt: 2,
                  gap: 0.5,
                  display: 'flex',
                  justifyContent: 'start',
                  alignContent: 'center',
                }}
              >
                <GroupIcon />
                <Typography>
                  <Typography
                    component="span"
                    fontWeight="bold"
                    sx={{ color: '#00789E' }}
                  >
                    {props.check?.filter((item) => item.type === 'check2').length ?? 0}명
                  </Typography>{' '}
                  참가 완료
                </Typography>
              </Box>
            </Box>
          }
        />
      )}
    </>
  );
}
